import { z } from 'zod';
import { chargeKindSchema, subscriptionBillingCadenceSchema, subscriptionPaymentMethodSchema, SubscriptionStatus, subscriptionStatusSchema, } from '../../partner-management/partner-subscription-management/index.js';
export const partnerCockpitChargeStatusSchema = z.enum(['Paid', 'Due', 'Overdue', 'Refunded', 'Cancelled']);
export const PartnerCockpitChargeStatus = partnerCockpitChargeStatusSchema.enum;
// Amounts are in gross.
export const partnerCockpitSubscriptionChargeSchema = z.object({
    uuid: z.uuid(),
    // Null unless the payment provider numbers the document.
    invoiceNumber: z.string().nullable(),
    issuedAt: z.iso.datetime().nullable(),
    periodStart: z.iso.datetime(),
    periodEnd: z.iso.datetime(),
    kind: chargeKindSchema,
    billingCadence: subscriptionBillingCadenceSchema,
    totalAmount: z.string(),
    status: partnerCockpitChargeStatusSchema,
    hasInvoiceDocument: z.boolean(),
});
export const partnerCockpitSubscriptionSchema = z.object({
    status: subscriptionStatusSchema,
    planName: z.string(),
    pricePerMonth: z.string(),
    commitmentTotal: z.string(),
    billingCadence: subscriptionBillingCadenceSchema,
    paymentMethod: subscriptionPaymentMethodSchema,
    nextBillingAt: z.iso.datetime().nullable(),
    nextPaymentAmount: z.string().nullable(),
    nextProlongationAt: z.iso.datetime().nullable(),
    cancelEffectiveAt: z.iso.datetime().nullable(),
    cancelWouldEndAt: z.iso.datetime().nullable(),
    endsCoveredPeriod: z.boolean(),
    isValidated: z.boolean(),
    canCancel: z.boolean(),
    canRevokeCancellation: z.boolean(),
    canManageBilling: z.boolean(),
    charges: partnerCockpitSubscriptionChargeSchema.array(),
});
export const partnerCockpitSubscriptionViewSchema = z.object({
    subscription: partnerCockpitSubscriptionSchema.nullable(),
});
export const partnerCockpitBillingPortalSchema = z.object({
    redirectUrl: z.string(),
});
export const isPartnerCockpitSubscriptionEnded = (subscription) => subscription.status === SubscriptionStatus.Terminated;
export const CANCELLATION_COMMENT_MAX_LENGTH = 2000;
export const cancelPartnerCockpitSubscriptionSchema = z.object({
    comment: z.string().max(CANCELLATION_COMMENT_MAX_LENGTH).optional(),
});
